var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function() {
          return [
            _c(
              "div",
              { staticClass: "single container-max page-content" },
              [
                _vm._t("breadcrumb"),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "row position-relative mt-5 single-item__top-container"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "col-12 col-md-6 carousel-wrapper",
                        class: {
                          "carousel-opacity":
                            _vm.currentVariation.item.free4 == "1"
                        }
                      },
                      [
                        _c("div", {
                          staticClass: "single__freetext-14 mb10",
                          domProps: {
                            innerHTML: _vm._s(_vm.currentVariation.item.free14)
                          }
                        }),
                        _vm._v(" "),
                        _vm._t("image-carousel")
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-5 offset-md-1 single-rightside my-3"
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "stick-in-parent",
                                rawName: "v-stick-in-parent"
                              }
                            ],
                            attrs: {
                              "data-sticky-container":
                                ".single-item__top-container"
                            }
                          },
                          [
                            _c("h1", { staticClass: "h2 title" }, [
                              _c("span", [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      _vm._f("itemName")(_vm.currentVariation)
                                    ) +
                                    "\n                                "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row align-items-center flex-md-row-reverse"
                              },
                              [
                                _vm.currentVariation.filter.hasManufacturer
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-12 col-md-5 col-lg-6 producertag h6 producer text-muted"
                                      },
                                      [
                                        _vm.currentVariation.item.manufacturer
                                          .logo
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "single-item__producer-container"
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src:
                                                      _vm.currentVariation.item
                                                        .manufacturer.logo,
                                                    alt:
                                                      _vm.currentVariation.item
                                                        .manufacturer
                                                        .externalName
                                                  }
                                                })
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "single-item__producer-container producer-no-image"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.currentVariation.item
                                                        .manufacturer
                                                        .externalName
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "col-12 col-md-7 col-lg-6" },
                                  [
                                    _vm.currentVariation.variation.availability
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "single__availability"
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "single__availability-indicator",
                                              class:
                                                "single__availability-indicator--" +
                                                _vm.currentVariation.variation
                                                  .availability.id
                                            }),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .availability.names.name
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row single-item__top-info" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col-lg-12 col-md-12" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "hidden-xs-down" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "col-lg-6 col-md-6" },
                                          [
                                            _c(
                                              "ul",
                                              _vm._l(
                                                _vm.currentVariation.properties,
                                                function(prop, index) {
                                                  return _c("li", [
                                                    _vm._v(
                                                      _vm._s(
                                                        prop.property.names.name
                                                      )
                                                    )
                                                  ])
                                                }
                                              ),
                                              0
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "hidden-sm-up" }, [
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-6 col-md-6" },
                                        [
                                          _vm.currentVariation.properties.length
                                            ? _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "toggle-single-item-info-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    "Artikel-Eigenschaften "
                                                  ),
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-chevron-down single-item__top-info--mobile-icon"
                                                  })
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "ul",
                                            {
                                              staticClass:
                                                "single-item__top-info--mobile"
                                            },
                                            _vm._l(
                                              _vm.currentVariation.properties,
                                              function(prop, index) {
                                                return _c("li", [
                                                  _vm._v(
                                                    _vm._s(
                                                      prop.property.names.name
                                                    )
                                                  )
                                                ])
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._t("before-price"),
                            _vm._v(" "),
                            _vm.currentVariation.filter.isSalable &&
                            _vm.variationGroupedProperties.length
                              ? _c("div", [_c("order-property-list")], 1)
                              : _vm._e(),
                            _vm._v(" "),
                            _c("graduated-prices"),
                            _vm._v(" "),
                            _c("item-price", {
                              attrs: {
                                "show-cross-price": _vm.isRecommendedPriceActive
                              }
                            }),
                            _vm._v(" "),
                            _vm._t("after-price"),
                            _vm._v(" "),
                            _c("div", { staticClass: "row my-3" }, [
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [
                                  _c("div", {
                                    staticClass: "single__freetext-4",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentVariation.item.free4
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm._t("before-add-to-basket")
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "w-100 add-to-basket-outer",
                                  class: {
                                    "hide-btn-qty":
                                      _vm.currentVariation.item.free4 == "1"
                                  }
                                },
                                [
                                  _c("add-to-basket", {
                                    attrs: {
                                      "variation-id":
                                        _vm.currentVariation.variation.id,
                                      "is-salable":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-children":
                                        !!_vm.currentVariation.filter &&
                                        _vm.currentVariation.filter
                                          .hasActiveChildren,
                                      "interval-quantity":
                                        _vm.currentVariation.variation
                                          .intervalOrderQuantity || 1,
                                      "minimum-quantity":
                                        _vm.currentVariation.variation
                                          .minimumOrderQuantity,
                                      "maximum-quantity":
                                        !!_vm.currentVariation.variation
                                          .maximumOrderQuantity &&
                                        _vm.currentVariation.variation
                                          .maximumOrderQuantity > 0
                                          ? _vm.currentVariation.variation
                                              .maximumOrderQuantity
                                          : null,
                                      "order-properties": _vm.currentVariation.properties.filter(
                                        function(prop) {
                                          return prop.property.isOderProperty
                                        }
                                      ),
                                      "has-order-properties":
                                        _vm.currentVariation.hasOrderProperties,
                                      "has-required-order-property":
                                        _vm.currentVariation
                                          .hasRequiredOrderProperty,
                                      "use-large-scale": false,
                                      "show-quantity": true,
                                      "item-url": _vm._f("itemURL")(
                                        _vm.currentVariation
                                      ),
                                      "is-variation-selected":
                                        _vm.isVariationSelected &&
                                        _vm.currentVariation.filter.isSalable,
                                      "has-price": _vm._f(
                                        "hasItemDefaultPrice"
                                      )(_vm.currentVariation)
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [_vm._t("after-add-to-basket")],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _vm._t("additional-content-after-add-to-basket"),
                            _vm._v(" "),
                            _vm.isWishListEnabled
                              ? _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-12" },
                                    [
                                      _c("add-to-wish-list", {
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "table",
                              {
                                staticClass:
                                  "table single-item__description-container--right-info"
                              },
                              [
                                _c("tbody", [
                                  _c("tr", [
                                    _c("td", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemId"
                                            )
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.variation.number
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentVariation.filter.hasManufacturer &&
                                  _vm.currentVariation.item.manufacturer
                                    .externalName !== ""
                                    ? _c("tr", [
                                        _c("td", [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemManufacturer"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.item
                                                .manufacturer.externalName
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  typeof _vm.currentVariation.barcodes !==
                                  "undefined"
                                    ? _c("tr", [
                                        _vm._m(0),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.barcodes[0]
                                                .code
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.model !== ""
                                    ? _c("tr", [
                                        _c("td", [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemModel"
                                                )
                                              )
                                            )
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.variation
                                                .model
                                            )
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.weightG !== ""
                                    ? _c("tr", [
                                        _vm._m(1),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.variation
                                                .weightG
                                            ) + " g"
                                          )
                                        ])
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentVariation.variation.weightNetG !==
                                  ""
                                    ? _c("tr", [
                                        _vm._m(2),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.currentVariation.unit.content
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.currentVariation.unit.names
                                                  .name
                                              )
                                          )
                                        ])
                                      ])
                                    : _vm._e()
                                ])
                              ]
                            )
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "single-item__description-container col-md-7"
                      },
                      [
                        _c("div", { staticClass: "my-5" }, [
                          _c(
                            "ul",
                            {
                              staticClass: "nav nav-tabs d-none d-md-flex",
                              attrs: { role: "tablist" }
                            },
                            [
                              _vm.isDescriptionTabActive
                                ? _c("li", { staticClass: "nav-item" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "nav-link active",
                                        attrs: {
                                          "data-toggle": "tab",
                                          href:
                                            "#details-" +
                                            _vm.currentVariation.variation.id,
                                          role: "tab"
                                        }
                                      },
                                      [_vm._v("Beschreibung")]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isTechnicalDataTabActive
                                ? _c("li", { staticClass: "nav-item" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "nav-link",
                                        class: {
                                          active:
                                            !_vm.isDescriptionTabActive &&
                                            _vm.isTechnicalDataTabActive
                                        },
                                        attrs: {
                                          "data-toggle": "tab",
                                          href:
                                            "#data-" +
                                            _vm.currentVariation.variation.id,
                                          role: "tab"
                                        }
                                      },
                                      [_vm._v("Zutaten / Nährwerte")]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._t("add-detail-tabs")
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "tab-content overflow-hidden" },
                            [
                              _c(
                                "ul",
                                {
                                  staticClass:
                                    "nav nav-tabs d-block d-md-none ",
                                  attrs: { role: "tablist" }
                                },
                                [
                                  _vm.isDescriptionTabActive
                                    ? _c("li", { staticClass: "nav-item" }, [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "nav-link active nav-link--inner",
                                            attrs: {
                                              "data-toggle": "tab",
                                              href:
                                                "#details-" +
                                                _vm.currentVariation.variation
                                                  .id,
                                              role: "tab"
                                            }
                                          },
                                          [_vm._v("Beschreibung")]
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isDescriptionTabActive
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "tab-pane active overflow-auto",
                                      attrs: {
                                        id:
                                          "details-" +
                                          _vm.currentVariation.variation.id,
                                        role: "tabpanel"
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "my-4 pl-md-0 col-12",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.currentVariation.texts
                                              .description
                                          )
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "ul",
                                {
                                  staticClass: "nav nav-tabs d-block d-md-none",
                                  attrs: { role: "tablist" }
                                },
                                [
                                  _c("li", { staticClass: "nav-item" }, [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "nav-link nav-link--inner",
                                        class: {
                                          active:
                                            !_vm.isDescriptionTabActive &&
                                            _vm.isTechnicalDataTabActive
                                        },
                                        attrs: {
                                          "data-toggle": "tab",
                                          href:
                                            "#data-" +
                                            _vm.currentVariation.variation.id,
                                          role: "tab"
                                        }
                                      },
                                      [_vm._v("Zutaten / Nährwerte")]
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isTechnicalDataTabActive
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "tab-pane overflow-auto",
                                      class: {
                                        active:
                                          !_vm.isDescriptionTabActive &&
                                          _vm.isTechnicalDataTabActive
                                      },
                                      attrs: {
                                        id:
                                          "data-" +
                                          _vm.currentVariation.variation.id,
                                        role: "tabpanel"
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticClass: "my-4 pl-md-0 col-12",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.currentVariation.texts
                                              .technicalData
                                          )
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._t("add-detail-tabs-content")
                            ],
                            2
                          )
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "single__crossselling" },
                  [_vm._t("item-list-container")],
                  2
                ),
                _vm._v(" "),
                _vm._t("feedback-container")
              ],
              2
            )
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("EAN")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Versandgewicht")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("b", [_vm._v("Inhalt")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }